import { AuthenticationType, DataLocationStorageType, } from '../../models/DataSourceDataCommon';
import { getNewGuid } from '@ane/core/lib/utils/CommonStringUtils';
import { getFileFormat, getDataSourceTypeLocation, validateBasicInfo, validateDataLocationInfo, validateParameterInfo, validateAvailabilityStreamInfo, genErrorMessageDataLocationInfo, getCosmosViewDefaultParameter, genErrorMessageParameterInfo, genErrorMessageAvailabilityStreamInfo, validateSpecialColumnsInfo, getProfileJobConfigurationFrequency, getProfileJobConfigurationFrequencyFriendlyName, } from '../../utils/DataSourceFormikSettingsUtils';
import { notDeleteKey } from '../../../DataSourceDetail/ducks/DataSourceDetailConstants';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import Logger from '@ane/core/lib/services/logging/Logger';
import { TelemetryEventName } from '../../../../constants/TelemetryEventName';
import { ProfilingOptions } from '../DataProfiling/DataProfilingComponent';
export const convertToPostParams = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    let storageType = props.storageType;
    const locationRes = getDataSourceTypeLocation(props);
    const experimentConfiguration = {
        RandomizationUnits: props.randomizationList
            ? props.randomizationList.map(({ ColumnName, NGPColumnTag, NGPStreamTag }) => ({
                Name: ColumnName,
                NGPColumnTag: NGPColumnTag ? (new RegExp(/\[|\]/).test(NGPColumnTag) ? NGPColumnTag : `[${NGPColumnTag}]`) : undefined,
                NGPStreamTag: NGPStreamTag ? (new RegExp(/\[|\]/).test(NGPStreamTag) ? NGPStreamTag : `[${NGPStreamTag}]`) : undefined,
            }))
            : [],
        TimeStamps: props.timestampList
            ? props.timestampList.map(({ ColumnName, NonNullable }) => ({ Name: ColumnName, Nullable: !NonNullable }))
            : [],
        Flights: props.flightList
            ? props.flightList.map(({ ColumnName, Example, Definition, Source }) => ({
                Name: ColumnName,
                Format: {
                    Source: Source,
                    Example: Example,
                    Definition: Definition,
                },
            }))
            : [],
    };
    let postParams = {
        Version: getNewGuid(),
        WorkspaceId: props.workspaceId,
        Name: props.name,
        DataSourceType: props.dataSourceType,
        Owners: props.owners,
        IsUTC: props.isUTC === 'True' ? true : false,
        OffsetInHours: props.isUTC === 'True' ? 0 : 8,
        CosmosLocation: storageType !== DataLocationStorageType.Cosmos ? null : locationRes,
        AzureBlobLocation: storageType !== DataLocationStorageType.AzureBlob ? null : locationRes,
        ADLSGen2Location: storageType !== DataLocationStorageType.ADLSGen2 ? null : locationRes,
        ADLSGen2CosmosViewLocation: storageType !== DataLocationStorageType.ADLSGen2CosmosView ? null : locationRes,
        AuthenticationId: (storageType === DataLocationStorageType.ADLSGen2 || storageType === DataLocationStorageType.ADLSGen2CosmosView) &&
            (props.authenticationType === AuthenticationType.ServicePrincipal || !props.authenticationType)
            ? props.authenticationId
            : '',
        ManagedIdentityId: (storageType === DataLocationStorageType.AzureBlob ||
            storageType === DataLocationStorageType.ADLSGen2 ||
            storageType === DataLocationStorageType.ADLSGen2CosmosView ||
            storageType === DataLocationStorageType.Cosmos) &&
            (props.authenticationType === AuthenticationType.ManagedIdentity || !props.authenticationType)
            ? props.managedIdentityId
            : '',
        RetentionDayParams: props.retentionDaysParams,
        MTLocations: storageType !== DataLocationStorageType.MT
            ? null
            : [
                {
                    DataPath: (_c = (_b = (_a = props.storageMTList) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.DataPath) !== null && _c !== void 0 ? _c : '',
                    EndPoint: (_f = (_e = (_d = props.storageMTList) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.EndPoint) !== null && _f !== void 0 ? _f : '',
                    Region: '',
                    SubCluster: (_j = (_h = (_g = props.storageMTList) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.SubCluster) !== null && _j !== void 0 ? _j : '',
                },
            ],
        FileFormat: getFileFormat(props),
        StorageType: storageType,
        AvailabilityStreams: props.streamList
            ? props.streamList.map(({ DataPath, VC, Cluster }) => ({
                DataPath,
                VC,
                Cluster,
            }))
            : [],
        Parameters: props.parameterList
            ? props.parameterList.map(({ Name, Value, Type, SampleValue }, key) => ({
                Name: Name,
                Value: Value,
                Type: Type,
                DefaultValue: (storageType === DataLocationStorageType.Cosmos || storageType === DataLocationStorageType.ADLSGen2CosmosView) &&
                    (key === 0 || key === 1)
                    ? `today("${SampleValue}")`
                    : SampleValue,
            }))
            : [],
        PartitionCount: props.partitionCount,
        IsOverrideDataSource: false,
        ExperimentConfiguration: experimentConfiguration,
        IsDataContractEnabled: props.IsDataContractEnabled,
        ProfileJobConfiguration: {
            RequireProfile: (_k = props.isEnableProfiling) !== null && _k !== void 0 ? _k : false,
            Frequency: getProfileJobConfigurationFrequency(props.profilingFrequency),
            LastProfileTime: null,
        },
        AAStreamConfig: {
            ExpiryDays: (_l = props.aaStreamConfig) === null || _l === void 0 ? void 0 : _l.ExpiryDays,
            LocationPrefix: (_m = props.aaStreamConfig) === null || _m === void 0 ? void 0 : _m.LocationPrefix,
        },
        SampleConfig: {
            MainDataSources: ((_o = props.sampleConfig) === null || _o === void 0 ? void 0 : _o.MainDataSources) || [],
            SampleDataSources: ((_p = props.sampleConfig) === null || _p === void 0 ? void 0 : _p.SampleDataSources) || [],
            Comment: (_q = props.sampleConfig) === null || _q === void 0 ? void 0 : _q.Comment,
        },
    };
    return postParams;
};
export const DataSourceCreateFormSettings = {
    mapPropsToValues: (props) => {
        return {
            name: '',
            dataSourceType: '',
            isUTC: 'False',
            owners: [],
            subscribers: [],
            storageType: '',
            storageList: {},
            storageMTList: [],
            parameterList: [],
            streamList: [],
            randomizationList: [{ ColumnName: '', NGPColumnTag: '', NGPStreamTag: '' }],
            flightList: [{ ColumnName: '', Format: '', Definition: '', Source: '', Example: '' }],
            timestampList: [{ ColumnName: '', NonNullable: false }],
            dataContractErrorDetails: null,
            IsDataContractEnabled: true,
            isEnableProfiling: false,
            profilingFrequency: ProfilingOptions.Manual,
            aaStreamConfig: {
                ExpiryDays: 30,
                LocationPrefix: null,
            },
        };
    },
    validate: (values, props) => {
        const initialValues = DataSourceCreateFormSettings.mapPropsToValues(props);
        let errors = {};
        errors = validateBasicInfo(values, props.workspaceId);
        errors = validateDataLocationInfo(values, errors, props.workspaceId, true);
        if (values.IsDataContractEnabled === true) {
            errors = validateSpecialColumnsInfo(values, errors, initialValues);
        }
        errors = validateParameterInfo(values, errors);
        errors = validateAvailabilityStreamInfo(values, errors);
        return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    handleSubmit: async (values, bag) => {
        var _a, _b, _c, _d, _e;
        (_b = (_a = bag.props).onSubmit) === null || _b === void 0 ? void 0 : _b.call(_a, {
            workspaceId: bag.props.workspaceId,
            name: values.name,
            dataSourceType: values.dataSourceType,
            owners: values.owners,
            subscribers: values.subscribers,
            retentionDaysParams: {
                DataSourceRetentionDays: values.retentionDays,
                DataSourceRetentionErrorMessage: values.retentionErrorMsg,
            },
            isUTC: values.isUTC,
            storageType: values.storageType,
            storageList: values.storageList,
            parameterList: values.parameterList,
            streamList: values.streamList,
            storageMTList: values.storageMTList,
            randomizationList: values.randomizationList,
            flightList: values.flightList,
            timestampList: values.timestampList,
            IsDataContractEnabled: values.IsDataContractEnabled,
            isEnableProfiling: values.isEnableProfiling,
            profilingFrequency: values.profilingFrequency,
            authenticationId: values.authenticationId,
            authenticationType: values.authenticationType,
            managedIdentityId: values.managedIdentityId,
            partitionCount: values.partitionCount,
            aaStreamConfig: {
                ExpiryDays: (_c = values.aaStreamConfig) === null || _c === void 0 ? void 0 : _c.ExpiryDays,
                LocationPrefix: (_d = values.aaStreamConfig) === null || _d === void 0 ? void 0 : _d.LocationPrefix,
            },
            sampleConfig: {
                MainDataSources: [],
                SampleDataSources: ((_e = values.linkedSampleDataSource) === null || _e === void 0 ? void 0 : _e.length) ? [values.linkedSampleDataSource[0]] : null,
                Comment: values.linkComment,
            },
        });
    },
};
export const getPlaceholderName = (storageType, index) => {
    if ((storageType === DataLocationStorageType.Cosmos || storageType === DataLocationStorageType.ADLSGen2CosmosView) &&
        index === 0) {
        return {
            Name: 'e.g. StartDate',
            Value: 'eg: "2020-01-01"',
            SampleValue: 'eg: "2020-01-01"',
        };
    }
    else if ((storageType === DataLocationStorageType.Cosmos || storageType === DataLocationStorageType.ADLSGen2CosmosView) &&
        index === 1) {
        return {
            Name: 'e.g. EndDate',
            Value: 'eg: "2020-01-01"',
            SampleValue: 'eg: "2020-01-01"',
        };
    }
    else {
        return undefined;
    }
};
export const parseCosmosDate = (defaultValue) => {
    if (defaultValue && /^today\("[-][0-9]+"\)$/.test(defaultValue)) {
        const match = defaultValue.match(/[-][0-9]+/g);
        return match ? match[0] : '';
    }
    else {
        return defaultValue;
    }
};
export const DataSourceEditFormSettings = {
    mapPropsToValues: (props) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        let storageMTList = [];
        if (!((_a = props.dataSourceItem) === null || _a === void 0 ? void 0 : _a.data)) {
            return {
                name: '',
                dataSourceType: '',
                isUTC: 'True',
                owners: [],
                subscribers: [],
                storageType: '',
                storageList: {},
                storageMTList: [],
                parameterList: [],
                streamList: [],
                randomizationList: [],
                flightList: [],
                timestampList: [],
                dataContractErrorDetails: null,
                IsDataContractEnabled: true,
                isEnableProfiling: false,
                profilingFrequency: ProfilingOptions.Manual,
                aaStreamConfig: {
                    ExpiryDays: 30,
                    LocationPrefix: null,
                },
            };
        }
        else {
            const data = (_b = props.dataSourceItem) === null || _b === void 0 ? void 0 : _b.data;
            let storageList = {};
            if (data === null || data === void 0 ? void 0 : data.StorageType) {
                if (data.StorageType === DataLocationStorageType.Cosmos) {
                    storageList = {
                        DataPath: data.CosmosLocation ? data.CosmosLocation.DataPath : '',
                        VC: (_d = (_c = data.CosmosLocation) === null || _c === void 0 ? void 0 : _c.VC) !== null && _d !== void 0 ? _d : '',
                        Cluster: (_f = (_e = data.CosmosLocation) === null || _e === void 0 ? void 0 : _e.Cluster) !== null && _f !== void 0 ? _f : '',
                    };
                    storageList = genErrorMessageDataLocationInfo(storageList);
                }
                else if (data.StorageType === DataLocationStorageType.AzureBlob) {
                    storageList = {
                        DataPath: data.AzureBlobLocation ? data.AzureBlobLocation.DataPath : '',
                        StorageAccount: data.AzureBlobLocation ? data.AzureBlobLocation.StorageAccount : '',
                        Container: data.AzureBlobLocation ? data.AzureBlobLocation.Container : '',
                    };
                    storageList = genErrorMessageDataLocationInfo(storageList);
                }
                else if (data.StorageType === DataLocationStorageType.ADLSGen2) {
                    storageList = {
                        DataPath: data.ADLSGen2Location ? data.ADLSGen2Location.DataPath : '',
                        StorageAccount: data.ADLSGen2Location ? data.ADLSGen2Location.StorageAccount : '',
                        Container: data.ADLSGen2Location ? data.ADLSGen2Location.Container : '',
                        Url: data.ADLSGen2Location ? (_g = data.ADLSGen2Location.KeyVaultAuthentication) === null || _g === void 0 ? void 0 : _g.Url : '',
                        SecretName: data.ADLSGen2Location ? (_h = data.ADLSGen2Location.KeyVaultAuthentication) === null || _h === void 0 ? void 0 : _h.SecretName : '',
                    };
                    storageList = genErrorMessageDataLocationInfo(storageList);
                }
                else if (data.StorageType === DataLocationStorageType.MT) {
                    storageMTList = data
                        ? (_j = data.MTLocations) === null || _j === void 0 ? void 0 : _j.map(({ Region, DataPath, EndPoint, SubCluster }, key) => ({
                            Region: Region,
                            DataPath: DataPath,
                            EndPoint: EndPoint,
                            SubCluster: SubCluster,
                            required: {
                                Region: '',
                                DataPath: '',
                                EndPoint: '',
                                SubCluster: '',
                            },
                        }))
                        : [];
                }
                else if (data.StorageType === DataLocationStorageType.ADLSGen2CosmosView) {
                    storageList = {
                        DataPath: data.ADLSGen2CosmosViewLocation ? data.ADLSGen2CosmosViewLocation.DataPath : '',
                        StorageAccount: data.ADLSGen2CosmosViewLocation ? data.ADLSGen2CosmosViewLocation.StorageAccount : '',
                        Container: data.ADLSGen2CosmosViewLocation ? data.ADLSGen2CosmosViewLocation.Container : '',
                    };
                }
            }
            let parameters = [];
            if (data.Parameters) {
                parameters = data.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => {
                    const isCosmosDate = (data.StorageType === DataLocationStorageType.Cosmos ||
                        data.StorageType === DataLocationStorageType.ADLSGen2CosmosView) &&
                        (key === 0 || key === 1);
                    const SampleValue = isCosmosDate ? parseCosmosDate(DefaultValue) : DefaultValue;
                    const deleteProp = isCosmosDate ? notDeleteKey : null;
                    const placeholder = getPlaceholderName(data.StorageType, key);
                    return {
                        Name: Name !== null && Name !== void 0 ? Name : '',
                        Value: Value !== null && Value !== void 0 ? Value : '',
                        Type: Type !== null && Type !== void 0 ? Type : '',
                        SampleValue: SampleValue !== null && SampleValue !== void 0 ? SampleValue : '',
                        delete: deleteProp,
                        required: {
                            Name: '',
                            Type: '',
                            Value: '',
                            SampleValue: '',
                        },
                        placeholder,
                    };
                });
            }
            else {
                switch (data.StorageType) {
                    case DataLocationStorageType.ADLSGen2CosmosView:
                    case DataLocationStorageType.Cosmos:
                        parameters = getCosmosViewDefaultParameter();
                        break;
                    default:
                        parameters = [];
                        break;
                }
            }
            parameters = genErrorMessageParameterInfo(parameters, data.StorageType === DataLocationStorageType.Cosmos);
            let streams = data.AvailabilityStreams
                ? data.AvailabilityStreams.map(({ DataPath, VC, Cluster }, key) => ({
                    DataPath: DataPath,
                    VC: VC,
                    Cluster: Cluster,
                    required: {
                        DataPath: '',
                        VC: '',
                        Cluster: '',
                    },
                    delete: null,
                }))
                : [];
            streams = genErrorMessageAvailabilityStreamInfo(streams);
            let randomizationList = ((_k = data.ExperimentConfiguration) === null || _k === void 0 ? void 0 : _k.RandomizationUnits)
                ? (_l = data.ExperimentConfiguration) === null || _l === void 0 ? void 0 : _l.RandomizationUnits.map(({ Name, NGPColumnTag, NGPStreamTag }, key) => ({
                    ColumnName: Name,
                    NGPColumnTag,
                    NGPStreamTag,
                }))
                : [];
            let timestampList = ((_m = data.ExperimentConfiguration) === null || _m === void 0 ? void 0 : _m.TimeStamps)
                ? (_o = data.ExperimentConfiguration) === null || _o === void 0 ? void 0 : _o.TimeStamps.map(({ Name, Nullable }, key) => {
                    var _a;
                    return ({
                        ColumnName: Name,
                        NonNullable: (_a = !Nullable) !== null && _a !== void 0 ? _a : false,
                    });
                })
                : [];
            let flightList = ((_p = data.ExperimentConfiguration) === null || _p === void 0 ? void 0 : _p.Flights)
                ? (_q = data.ExperimentConfiguration) === null || _q === void 0 ? void 0 : _q.Flights.map(({ Name, Format }, key) => ({
                    ColumnName: Name,
                    Format: Format.Example,
                    Source: Format.Source,
                    Example: Format.Example,
                    Definition: Format.Definition,
                }))
                : [];
            let dataContractErrorDetails = null;
            if ((_u = (_t = (_s = (_r = props.dataSourceStatus) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.DataSourceValidationInfo) === null || _t === void 0 ? void 0 : _t.Report) === null || _u === void 0 ? void 0 : _u.ErrorDetails) {
                try {
                    const errorDetails = JSON.parse((_x = (_w = (_v = props.dataSourceStatus.data) === null || _v === void 0 ? void 0 : _v.DataSourceValidationInfo) === null || _w === void 0 ? void 0 : _w.Report) === null || _x === void 0 ? void 0 : _x.ErrorDetails);
                    dataContractErrorDetails = errorDetails.DataContractColumnError;
                }
                catch (e) {
                    const dataContractErrorDetails = {
                        Details: 'Failed to parse error details',
                        DataContractColumnError: null,
                    };
                    Logger.log(TelemetryEventName.App_DSMS_DataContract_ParseError, dataContractErrorDetails);
                }
            }
            return {
                name: data.Name,
                dataSourceType: data.DataSourceType,
                isUTC: data.IsUTC ? 'True' : 'False',
                retentionErrorMsg: (_z = (_y = data.RetentionDayParams) === null || _y === void 0 ? void 0 : _y.DataSourceRetentionErrorMessage) !== null && _z !== void 0 ? _z : '',
                retentionDays: ((_0 = data.RetentionDayParams) === null || _0 === void 0 ? void 0 : _0.DataSourceRetentionDays)
                    ? (_1 = data.RetentionDayParams) === null || _1 === void 0 ? void 0 : _1.DataSourceRetentionDays.toString()
                    : '',
                owners: data.Owners ? data.Owners : [],
                subscribers: [],
                storageType: data === null || data === void 0 ? void 0 : data.StorageType,
                storageList: storageList,
                storageMTList: storageMTList,
                parameterList: parameters,
                streamList: streams,
                randomizationList: randomizationList,
                flightList: flightList,
                timestampList: timestampList,
                dataContractErrorDetails: dataContractErrorDetails,
                IsDataContractEnabled: !!(data === null || data === void 0 ? void 0 : data.IsDataContractEnabled),
                authenticationId: data.AuthenticationId,
                managedIdentityId: data.ManagedIdentityId,
                isEnableProfiling: !!(data === null || data === void 0 ? void 0 : data.IsDataContractEnabled) &&
                    !!((_2 = data === null || data === void 0 ? void 0 : data.ProfileJobConfiguration) === null || _2 === void 0 ? void 0 : _2.RequireProfile) &&
                    EnvironmentService.releaseDSMSdataprofiling(),
                partitionCount: data.PartitionCount,
                profilingFrequency: getProfileJobConfigurationFrequencyFriendlyName((_3 = data === null || data === void 0 ? void 0 : data.ProfileJobConfiguration) === null || _3 === void 0 ? void 0 : _3.Frequency),
                aaStreamConfig: {
                    ExpiryDays: (_5 = (_4 = data === null || data === void 0 ? void 0 : data.AAStreamConfig) === null || _4 === void 0 ? void 0 : _4.ExpiryDays) !== null && _5 !== void 0 ? _5 : 30,
                    LocationPrefix: (_6 = data === null || data === void 0 ? void 0 : data.AAStreamConfig) === null || _6 === void 0 ? void 0 : _6.LocationPrefix,
                },
                linkedSampleDataSource: ((_7 = data === null || data === void 0 ? void 0 : data.SampleConfig) === null || _7 === void 0 ? void 0 : _7.SampleDataSources) || [],
                linkComment: (_8 = data === null || data === void 0 ? void 0 : data.SampleConfig) === null || _8 === void 0 ? void 0 : _8.Comment,
                sampleConfig: {
                    MainDataSources: [],
                    SampleDataSources: ((_9 = data === null || data === void 0 ? void 0 : data.SampleConfig) === null || _9 === void 0 ? void 0 : _9.SampleDataSources) || [],
                    Comment: (_10 = data === null || data === void 0 ? void 0 : data.SampleConfig) === null || _10 === void 0 ? void 0 : _10.Comment,
                },
            };
        }
    },
    validate: (values, props) => {
        let errors = {};
        const initialValues = DataSourceEditFormSettings.mapPropsToValues(props);
        errors = validateBasicInfo(values, props.workspaceId);
        errors = validateDataLocationInfo(values, errors, props.workspaceId, false);
        if (values.IsDataContractEnabled === true) {
            errors = validateSpecialColumnsInfo(values, errors, initialValues);
        }
        errors = validateParameterInfo({ ...values, parameterList: values.parameterList }, errors);
        errors = validateAvailabilityStreamInfo({ ...values, streamList: values.streamList }, errors);
        return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    handleSubmit: async (values, bag) => {
        var _a, _b;
        (_b = (_a = bag.props).savePanel) === null || _b === void 0 ? void 0 : _b.call(_a, values);
    },
};

//# sourceMappingURL=DataSourceCreateFormSettings.js.map
